<template>
  <div>
    <div v-if="hasPermissionToView">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="$route.meta.title"
            :link="[
              { text: 'Tài chính', href: '/#', disabled: false },
              { text: $route.meta.title, disabled: true }
            ]"
          />
        </div>
        <v-spacer />
        <div class="d-flex align-end">
          <ExcelExport />
          <CreateHeadDialog @onAddHeadSuccess="onAddHeadSuccess" v-if="hasPermissionToCreate" :key="router" />
        </div>
      </div>

      <v-card outlined class="pa-9 mx-4 mb-6 elevation-0">
        <HeadFilter ref="headFeeFilter" :key="router" />
      </v-card>

      <v-card outlined class="mx-4 elevation-0" md>
        <HeadTable :key="router" />
      </v-card>
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Page403 from '@/views/Page403.vue'
import CreateHeadDialog from './head-list/CreateHeadDialog.vue'
import ExcelExport from './head-list/ExcelExport.vue'
import HeadFilter from './head-list/HeadFilter.vue'
import HeadTable from './head-list/HeadTable.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Breadcrumbs,
    CreateHeadDialog,
    Page403,
    ExcelExport,
    HeadFilter,
    HeadTable,
  },
  data() {
    return {
      dialog: false,
      createDialog: false
    }
  },
  created() {
    this.setRouter(this.$route.params.category)
  },
  computed: {
    ...mapState('salaryHead', ['router', 'searchParams']),
    pathName() {
      return this.$route.fullPath
    },
    hasPermissionToView() {
      return true
    },
    hasPermissionToCreate() {
      return true
    }
  },
  methods: {
    ...mapActions('salaryHead', ['setRouter']),
    onAddHeadSuccess() {
      this.$refs.headFeeFilter.onHeadAddedSuccess()
    }
  },
  watch: {
    pathName() {
      this.setRouter(this.$route.params.category)
    }
  }
}
</script>
